import { PaymentMethodCombinedProps } from './types';

const usePresenter = (props: PaymentMethodCombinedProps): PaymentMethodCombinedProps => {
  return props;
};

export default usePresenter;
